module.exports = __webpack_public_path__ + "static/media/training-site-icon.5963b762.svg";